import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-me-inbox',
  templateUrl: './me-inbox.component.html',
  styleUrls: ['./me-inbox.component.css']
})
export class MeInboxComponent implements OnInit, OnDestroy {
  @ViewChild("inputSearch") meuinputSearch: ElementRef;
  hideCL: boolean = false;
  inputsearch: any = '';
  modoBusca: boolean = false;
  qIdx: any = 0;
  urlFoto: any = '';
  arrChats: any[] = [];
  td: any = '';
  yd: any = '';
  intervalListChat: any = '';
  acIntent: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public dialog: MatDialog, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    //this.hideCL = true;
    this.carregarChats();
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.tmaService.eventoFS(true);

  }
  ngOnDestroy() {
    clearInterval(this.intervalListChat);
    this.tmaService.eventoFS(false);
    if(!this.acIntent){
      //this.router.navigate(['/home']);
      //time campeão
      //this.voltar();
    }
    
  }

  voltar() {
    if (this.modoBusca) {
      this.modoBusca = false;
    }
    else {
      //this._location.back();
      this.router.navigate(['/home']);
    }

  }
  carregarChats() {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      i: this.qIdx
    };
    this.tmaService.listarChats(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.arrChats = qRes['allChat'];
        this.td = qRes['today'];
        this.yd = qRes['yesterday'];
        //this.buscarInfoUser(this.tmaService.hcNomeUsuario);
        this.intervalListChat = setInterval(() => {
          this.brokerChats();
        }, 45000);

      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  brokerChats() {
    //return false;
    //this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      i: this.qIdx,
      qtdatual: 0,
    };
    this.tmaService.brokerListChat(customParams).subscribe((qRes) => {
      //this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.arrChats = qRes['allChat'];
        this.td = qRes['today'];
        this.yd = qRes['yesterday'];
        //this.buscarInfoUser(this.tmaService.hcNomeUsuario);
      }
      else {
        // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        //   disableClose: true,
        //   data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        // })
      }
    },
      (error) => {
        this.hideCL = true;
        // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        //   disableClose: true,
        //   data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        // });
      })

  }

  digitando(textoBusca: any): void {

  }
  ativarBusca(): void {
    this.modoBusca = true;
    setTimeout(() => { // this will make the execution after the above boolean has changed
      this.meuinputSearch.nativeElement.focus();
    }, 300);
  }
  buscaFim(): void {
    setTimeout(() => {
      this.modoBusca = false;
    }, 100);
  }
  verMsg(nomeChat: any): void {
    console.log(nomeChat);
    this.acIntent = true;
    this.tmaService.paginaAnterior  = 'me/inbox';
    this.router.navigate(['/me/i/' + nomeChat]);
    //   const atendimentOffDialog = this.dialog.open(AlertaSimplesDialog, {
    //     disableClose:true,
    //     data: {textoAlerta: "Implementação pendente...", iconAlerta: 'warning'}
    // })
  }
  verContatos() :void{
    this.acIntent = true;
    this.router.navigate(['/me/contatos/listar'], {replaceUrl: false});
  }
}
